// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-tabs/~/rc-animate/lib/index.js
 ** module id = 314
 ** module chunks = 0
 **/